import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#3d4853',
        secondary: '#9e9e9e',
        cyan: '#2cbbe8',
        green: '#48dc6b',
        orange: 'ffa600',
        red: 'fe5533',
        purple: '#6b71e5',
        blue: '0091ff',
        'light-blue': '#61d3fe',
        pink: '#ff4866',
        yellow: '#ffd100',
        grey: '#9fa1a5',
      },
      dark: {
        primary: '#3d4853',
        secondary: '#9e9e9e',
        cyan: '#2cbbe8',
        green: '#48dc6b',
        orange: 'ffa600',
        red: 'fe5533',
        purple: '#6b71e5',
        blue: '0091ff',
        lightBlue: '#61d3fe',
        pink: '#ff4866',
        yellow: '#ffd100',
        grey: '#9fa1a5'
      }
    }
  }
});
